module.exports = "/_next/static/images/DevelopOnSegment@2x-07d717aaabf4ea29f47b166be43339f4.webp";